import type { ProductInput } from '@shop-monorepo/types';
import React from 'react';

import { useListReturn } from '../../hooks/useListReturn';
import { useCreateProduct } from '../../hooks/useProductQueries';
import { ROUTES } from '../../routes/routes';

import { ProductForm } from './ProductForm';

export const CreateProductForm: React.FC = () => {
  const { goToList } = useListReturn(ROUTES.PRODUCTS);
  const { mutateAsync: createProduct, isPending: isSubmitting } = useCreateProduct();

  const handleSubmit = async (values: ProductInput) => {
    await createProduct(values);
    goToList();
  };

  return <ProductForm onSubmit={handleSubmit} isSubmitting={isSubmitting} />;
};
